import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningConceptDetailsBuilder(apiClient: AxiosInstance) {
  return async function getLearningConceptDetails(
    id: number
  ): Promise<ILearning.LearningConceptByConcept | null> {
    try {
      const response = await apiClient.get(`/learning/api/concepts/${id}/`);
      return response.data;
    } catch {
      return null;
    }
  };
}
